/**
 * The Currency Rates route table (FSD 1.2.7.10).
 *
 * Replaces the legacy `/fx/rates` screen. The orchestrator spreads
 * `ENTERPRISE_CURRENCY_RATE_ROUTES` into the router, redirects the old path and
 * adds the nav entry — this packet owns neither shared file.
 */

import type { RouteRecordRaw } from 'vue-router'

import { CURRENCY_RATE_PERMISSIONS } from '@/modules/enterprise/currency-rates/permissions'

export const CURRENCY_RATES_PATH = '/enterprise/currency-rates'

export function currencyRatesRoute(): string {
  return CURRENCY_RATES_PATH
}

export const ENTERPRISE_CURRENCY_RATE_ROUTES: RouteRecordRaw[] = [
  {
    path: CURRENCY_RATES_PATH,
    name: 'enterprise-currency-rates',
    component: () => import('@/modules/enterprise/currency-rates/CurrencyRatesView.vue'),
    meta: {
      titleKey: 'enterprise.currencyRates.routeTitles.list',
      permission: CURRENCY_RATE_PERMISSIONS.read,
    },
  },
]
